// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2oy2R","cell":"ColumnAccessor_cell__2kIxY","firstCellAccent":"ColumnAccessor_firstCellAccent__Q2t2p"};